var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    { staticClass: "no-swipeback", attrs: { id: "mandate-dbtr" } },
    [
      _c(
        "div",
        { staticClass: "mandate-dbtr-wrapper" },
        [
          _c("page-outline", {
            attrs: { title: _vm.$t("mandate.dbtr_mandate_pagetitle") },
            scopedSlots: _vm._u([
              {
                key: "pageContent",
                fn: function () {
                  return [
                    _c(
                      "b-container",
                      { attrs: { fluid: "" } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-center" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "mt-3", attrs: { cols: "12" } },
                              [
                                _vm.docusignUrl
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "docusign-signing-container",
                                      },
                                      [
                                        _c("iframe", {
                                          staticClass:
                                            "docusign-signing-iframe",
                                          attrs: {
                                            src: _vm.docusignUrl,
                                            frameborder: "0",
                                            allow: "clipboard-write",
                                          },
                                        }),
                                      ]
                                    )
                                  : !_vm.signedViewMode
                                  ? _c(
                                      "div",
                                      [
                                        _vm.isDbtr
                                          ? _c(
                                              "form-accordion",
                                              {
                                                attrs: {
                                                  title: _vm.$t(
                                                    "mandate.mandate_info"
                                                  ),
                                                  isTitleUpperCase: false,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.tx_type"
                                                                ),
                                                              inputValue:
                                                                _vm.$t(
                                                                  "mandate." +
                                                                    _vm.active
                                                                ),
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.creation_date"
                                                                ) ||
                                                                "Creation date",
                                                              inputValue:
                                                                _vm.formattedCreationDate,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate_details.message_type"
                                                                ) ||
                                                                "Message type",
                                                              inputValue:
                                                                _vm.message_type,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.underlying_contract_id"
                                                                ),
                                                              inputValue:
                                                                _vm.ctrDisplay,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.reason_mandate"
                                                                ) || "Reason",
                                                              inputValue:
                                                                _vm.reason_mandate,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate_details.status"
                                                                ) || "Status",
                                                              inputValue:
                                                                _vm.mandateStatusLabel,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isDbtr
                                          ? _c(
                                              "form-accordion",
                                              {
                                                attrs: {
                                                  title:
                                                    _vm.$t("mandate.dbtr_info"),
                                                  isTitleUpperCase: false,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        String(
                                                          _vm.mode_sign
                                                        ) !== "3"
                                                          ? _c("iban-input", {
                                                              ref: "dbtrIbanInput",
                                                              attrs: {
                                                                label:
                                                                  _vm.$t(
                                                                    "mandate.dbtr_iban"
                                                                  ),
                                                                required: true,
                                                                hint:
                                                                  _vm.$t(
                                                                    "mandate.iban_hint"
                                                                  ) || "",
                                                                isMandatory: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.dbtr_iban,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.dbtr_iban =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "dbtr_iban",
                                                              },
                                                            })
                                                          : _c(
                                                              "div",
                                                              [
                                                                !_vm.dbtr_iban
                                                                  ? [
                                                                      !_vm.dbtr_iban
                                                                        ? _c(
                                                                            "b-button",
                                                                            {
                                                                              staticClass:
                                                                                "btnFilter_2",
                                                                              attrs:
                                                                                {
                                                                                  disabled:
                                                                                    !_vm.urlAisp,
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  _vm.openAisp,
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "mandate.get_iban"
                                                                                    )
                                                                                  ) +
                                                                                  "\n                          "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  : _c(
                                                                      "form-read-group-label-input",
                                                                      {
                                                                        attrs: {
                                                                          inputLabel:
                                                                            _vm.$t(
                                                                              "mandate.dbtr_iban"
                                                                            ),
                                                                          inputValue:
                                                                            _vm.dbtr_iban,
                                                                        },
                                                                      }
                                                                    ),
                                                              ],
                                                              2
                                                            ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_name"
                                                                ),
                                                              inputValue:
                                                                _vm.dbtr_name,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-2 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_email"
                                                                ) || "Email",
                                                              inputValue:
                                                                _vm.dbtr_email,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_addr"
                                                                ) || "Address",
                                                              inputValue:
                                                                _vm.dbtr_addr,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-2 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_city"
                                                                ) || "City",
                                                              inputValue:
                                                                _vm.dbtr_city,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.cdtr_ctry"
                                                                ) ||
                                                                "Country of residence",
                                                              inputValue:
                                                                _vm.dbtr_country,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("b-row", {
                                                  staticClass:
                                                    "ml-0 mt-2 mb-4 mr-5 form-group",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-3 mb-2 mr-5 form-group align-items-center",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "10" } },
                                                      [
                                                        _c(
                                                          "b-form-checkbox",
                                                          {
                                                            attrs: {
                                                              checked:
                                                                _vm.hasThirdPartyDebtor,
                                                              disabled: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Third party debtor (different from the debited account holder)\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.hasThirdPartyDebtor
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "b-row",
                                                          {
                                                            staticClass:
                                                              "ml-0 mt-5 mb-4 mr-5 form-group",
                                                          },
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "form-read-group-label-input",
                                                                  {
                                                                    attrs: {
                                                                      inputLabel:
                                                                        "Third party debtor BIC",
                                                                      inputValue:
                                                                        _vm.dbtrPSP_bic ||
                                                                        "—",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-row",
                                                          {
                                                            staticClass:
                                                              "ml-0 mt-2 mb-4 mr-5 form-group",
                                                          },
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "form-read-group-label-input",
                                                                  {
                                                                    attrs: {
                                                                      inputLabel:
                                                                        "Third party debtor name",
                                                                      inputValue:
                                                                        _vm.dbtrPSP_name ||
                                                                        "—",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "form-read-group-label-input",
                                                                  {
                                                                    attrs: {
                                                                      inputLabel:
                                                                        "Third party debtor address",
                                                                      inputValue:
                                                                        _vm.dbtrPSP_addr ||
                                                                        "—",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-row",
                                                          {
                                                            staticClass:
                                                              "ml-0 mt-2 mb-6 mr-5 form-group",
                                                          },
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "form-read-group-label-input",
                                                                  {
                                                                    attrs: {
                                                                      inputLabel:
                                                                        "Third party debtor city",
                                                                      inputValue:
                                                                        _vm.dbtrPSP_city ||
                                                                        "—",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "form-read-group-label-input",
                                                                  {
                                                                    attrs: {
                                                                      inputLabel:
                                                                        "Third party debtor country",
                                                                      inputValue:
                                                                        _vm.dbtrPSP_ctry ||
                                                                        "—",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showMandateLanguage
                                          ? _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "ml-0 mt-4 mb-3 mr-5 form-group",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "5" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.mandate_language"
                                                              ) ||
                                                                "Langue du mandat"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-form-radio-group",
                                                      {
                                                        attrs: {
                                                          name: "mandate-language",
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.mandateLanguage,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.mandateLanguage =
                                                              $$v
                                                          },
                                                          expression:
                                                            "mandateLanguage",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.mandateLanguageOptions,
                                                        function (option) {
                                                          return _c(
                                                            "b-form-radio",
                                                            {
                                                              key: option.value,
                                                              attrs: {
                                                                value:
                                                                  option.value,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    option.text
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isDbtr
                                          ? _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "min-w-100 justify-content-end align-items-center",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-end mt-3",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "btnFilter_2 mr-2",
                                                        attrs: {
                                                          disabled:
                                                            !_vm.canAccept ||
                                                            _vm.isSubmitting,
                                                        },
                                                        on: {
                                                          click: _vm.onSend,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.accept"
                                                              ) ||
                                                                "Accept & Sign"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "back-button btnFilter_2",
                                                        attrs: {
                                                          disabled:
                                                            _vm.isSubmitting,
                                                        },
                                                        on: {
                                                          click: _vm.onRefuse,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.refus"
                                                              ) || "Refuse"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _vm.isDbtr
                                          ? _c(
                                              "form-accordion",
                                              {
                                                attrs: {
                                                  title: _vm.$t(
                                                    "mandate.mandate_info"
                                                  ),
                                                  isTitleUpperCase: false,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.tx_type"
                                                                ),
                                                              inputValue:
                                                                _vm.$t(
                                                                  "mandate." +
                                                                    _vm.active
                                                                ),
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.creation_date"
                                                                ) ||
                                                                "Creation date",
                                                              inputValue:
                                                                _vm.formattedCreationDate ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.underlying_contract_id"
                                                                ),
                                                              inputValue:
                                                                _vm.ctrDisplay ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.reason_mandate"
                                                                ) || "Reason",
                                                              inputValue:
                                                                _vm.reason_mandate ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate_details.status"
                                                                ) || "Status",
                                                              inputValue:
                                                                _vm.mandateStatusLabel,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isDbtr
                                          ? _c(
                                              "form-accordion",
                                              {
                                                attrs: {
                                                  title:
                                                    _vm.$t("mandate.dbtr_info"),
                                                  isTitleUpperCase: false,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_iban"
                                                                ),
                                                              inputValue:
                                                                _vm.dbtr_iban ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_name"
                                                                ),
                                                              inputValue:
                                                                _vm.dbtr_name ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-2 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_email"
                                                                ) || "Email",
                                                              inputValue:
                                                                _vm.dbtr_email ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_addr"
                                                                ) || "Address",
                                                              inputValue:
                                                                _vm.dbtr_addr ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-2 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_city"
                                                                ) || "City",
                                                              inputValue:
                                                                _vm.dbtr_city ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                _vm.$t(
                                                                  "mandate.dbtr_country"
                                                                ) || "Country",
                                                              inputValue:
                                                                _vm.iso2ToCountryName(
                                                                  _vm.dbtr_country
                                                                ) || "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasThirdPartyDebtor ||
                                        _vm.dbtrPSP_name ||
                                        _vm.dbtrPSP_bic ||
                                        _vm.dbtrPSP_addr ||
                                        _vm.dbtrPSP_city ||
                                        _vm.dbtrPSP_ctry
                                          ? _c(
                                              "form-accordion",
                                              {
                                                attrs: {
                                                  title: "Third party debtor",
                                                  isTitleUpperCase: false,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-4 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                "Third party debtor BIC",
                                                              inputValue:
                                                                _vm.dbtrPSP_bic ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-2 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                "Third party debtor name",
                                                              inputValue:
                                                                _vm.dbtrPSP_name ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                "Third party debtor address",
                                                              inputValue:
                                                                _vm.dbtrPSP_addr ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "ml-0 mt-2 mb-4 mr-5 form-group",
                                                  },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                "Third party debtor city",
                                                              inputValue:
                                                                _vm.dbtrPSP_city ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "5" } },
                                                      [
                                                        _c(
                                                          "form-read-group-label-input",
                                                          {
                                                            attrs: {
                                                              inputLabel:
                                                                "Third party debtor country",
                                                              inputValue:
                                                                _vm.dbtrPSP_ctry ||
                                                                "—",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "form-accordion",
                                          {
                                            attrs: {
                                              title: "Date",
                                              isTitleUpperCase: false,
                                            },
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "ml-0 mt-2 mb-4 mr-5 form-group",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "5" } },
                                                  [
                                                    _c(
                                                      "form-read-group-label-input",
                                                      {
                                                        attrs: {
                                                          inputLabel:
                                                            _vm.outcomeDateLabel,
                                                          inputValue:
                                                            _vm.formattedOutcomeDate,
                                                        },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mt-5 mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { sm: "12" } },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "mandate.qr_help"
                                                        ),
                                                    },
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "ml-5" },
                                                  [
                                                    _vm.qrCodeDataUrl
                                                      ? _c("img", {
                                                          staticStyle: {
                                                            "max-width":
                                                              "180px",
                                                          },
                                                          attrs: {
                                                            src: _vm.qrCodeDataUrl,
                                                            alt: "Mandate access QR Code",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "min-w-100 justify-content-end align-items-center",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end mt-3",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                (_vm.signedPdfBase64 ||
                                                  _vm.signedPdfUrl) &&
                                                !_vm.isPublic
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "btnFilter_2",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            $event.preventDefault()
                                                            return _vm.downloadSignedPdf.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.download_pdf"
                                                              ) ||
                                                                "Télécharger le PDF"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }